import { Tooltip, Upload, Button } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { AppContext } from '@utils/AppContext';
import styles from './toolBoxNew.module.scss'



import IconUndo from '@assets/images/icon_undo.svg'
import IconUndoActived from '@assets/images/icon_undo_actived.svg';
import IconReset from '@assets/images/icon_reset.svg'
import IconResetActived from '@assets/images/icon_reset_actived.svg';
import IconCompare from '@assets/images/icon_compare.svg';
import IconTips from '@assets/images/icon_tips.svg';
import { AIEditContext } from '../../AIEditContext';

const ToolBox = (props) => {
    const {
        showCompare,
        compare,
        revoke,
        restore,
        reset,
        download,
        uploadCb,
    } = props

    const { needPay } = useContext(AIEditContext)

    const onUpload = (file) => {
        uploadCb(file)
        return false
    }

    const revokeDisabled = useRef(true)
    const revokeTrigger = useRef()
    useEffect(() => {
        if (revoke) {
            revokeDisabled.current = revoke.disabled
            revokeTrigger.current = revoke.trigger
        }
    }, [revoke])
    const handleUndo = (event) => {
        if (event.ctrlKey) {
            if (event.key == 'z') { // CTRL + Z 撤销
                if (revokeTrigger.current && !revokeDisabled.current) {
                    revokeTrigger.current()
                }
            }
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleUndo);

        return () => {
            document.removeEventListener('keydown', handleUndo);
        }
    }, [])

    return (
        <div className={`${styles.edit_right_r} ${styles.tool_box}`}>
            <div className={styles.edit_btn_list}>
                {
                    compare && <img
                        src={compare.disabled ? IconCompare : IconCompare} style={{ marginRight: '10px' }}
                        className={compare.disabled ? `${styles.disabled_img}` : `${styles.active_img}`}
                        onClick={compare.trigger} alt="" />
                }
                {
                    revoke && <img
                        src={revoke.disabled ? IconUndo : IconUndoActived}
                        className={revoke.disabled ? `${styles.disabled_img}` : `${styles.active_img}`}
                        onClick={revoke.trigger} alt="" />
                }
                {
                    restore && <img
                        src={restore.disabled ? IconUndo : IconUndoActived} style={{ transform: 'rotateY(-180deg)' , marginRight: '10px'}}
                        className={restore.disabled ? `${styles.disabled_img}` : `${styles.active_img}`}
                        onClick={restore.trigger} alt="" />
                }
                {
                    reset && <img
                        src={reset.disabled ? IconReset : IconResetActived}
                        className={reset.disabled ? `${styles.disabled_img}` : `${styles.active_img}`}
                        onClick={reset.trigger} alt="" />
                }
            </div>
            <div className={styles.edit_btn_list2}>
                <div className={styles.ReuploadBox}>
                    <Upload
                        accept='image/jpeg,image/png,image/webp,image/avif'
                        listType="picture-card"
                        className={styles.Uploader}
                        showUploadList={false}
                        beforeUpload={onUpload}
                    >
                        <Button className={styles.vip_btn}>重新上传</Button>
                    </Upload>
                </div>
                {
                    download &&
                    <Button
                        disabled={download.disabled}
                        className={styles.vip_btn}
                        type='primary'
                        onClick={download.trigger}>
                        下载
                        {
                            needPay &&
                            <div style={{ display: 'flex', alignItems: 'baseline' }}>
                                <span>（消耗&nbsp;</span>
                                <img style={{ width: '10px', height: '10px' }} src={require('@assets/images/arcbean2.png')} />&nbsp;
                                <span> 5）</span>
                            </div>
                        }
                    </Button>
                }
            </div>


        </div>
    )
}

export default ToolBox